import React from "react";
import { FOOTER_LINK_GROUPS } from "../../content/footerLinks.js";
import { Link } from "react-router-dom";
import { useCookieConsent } from "../../consent/CookieConsentContext.jsx";

export function Footer() {
  const { openPreferences } = useCookieConsent();

  return (
    <footer className="bg-slate-950 text-slate-100 mt-16 [&_a]:text-slate-100 [&_a:hover]:text-amber-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-8 md:grid-cols-2 lg:grid-cols-5">
        <div>
          <h2 className="text-lg font-semibold"><Link to="/">SalesPartner</Link></h2>
          <p className="mt-4 text-sm text-slate-300">
            Digital gruppförsäljning med personliga säljlänkar, QR-koder och val mellan direktleverans och
            gemensam leverans.
          </p>
        </div>
        {FOOTER_LINK_GROUPS.map((group) => (
          <nav key={group.title} aria-label={group.title}>
            <h2 className="text-sm font-semibold tracking-wide uppercase text-slate-400">{group.title}</h2>
            <ul className="mt-4 space-y-2 text-sm">
              {group.links.map((link) => (
                <li key={link.to}><Link to={link.to} className="hover:text-amber-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300">{link.label}</Link></li>
              ))}
            </ul>
          </nav>
        ))}
        <div>
          <h2 className="text-sm font-semibold tracking-wide uppercase text-slate-400">Kontakt</h2>
          <ul className="mt-4 text-sm space-y-2">
            <li>E-post: <a href="mailto:info@salespartner.se" className="hover:text-amber-300">info@salespartner.se</a></li>
            <li>Telefon: <a href="tel:0101825000" className="hover:text-amber-300">010-182 50 00</a></li>
            <li>EMW Trading AB, org.nr 5594624669</li>
            <li>Skogssvedjegatan 35 b, 506 49 Borås</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row items-center justify-between text-xs text-slate-400 gap-2">
          <p>© {new Date().getFullYear()} SalesPartner. Alla rättigheter förbehållna.</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <button type="button" onClick={openPreferences} className="hover:text-amber-300">
              Ändra cookieinställningar
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
